import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

// TODO: check if there is a way to clean this up (*cough*<attachmentFiles /><attachments />*cough*)
const typeSpecialOffer = gql`
    type SpecialOffer {
      id: ID
      activeFrom: String
      activeUntil: String
      appliesToAllArticle: Boolean
      attachmentFiles: [JSONObject]
      attachmentImages: [JSONObject]
      creationAt: String
      modifiedAt: String
      name: String
      targetContainer: Boolean
      appliedToVariants: [Article]
      appliedToBundles: [Bundle]
    }

    type SpecialOffers {
      total: Int
      items: [SpecialOffer]
    }

    type Query {
      specialOffers(
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.LIMIT}
        sort: Sort
        sortWithinLimits: Boolean = false
        lang: String = ""
        cdn: Boolean = true
        loggedInBranch: String
        customerId: ID 
      ): SpecialOffers

      specialOffer(
        id: ID! 
        loggedInBranch: String
        customerId: String
      ): SpecialOffer
    }
`

export { typeSpecialOffer }

export default typeSpecialOffer
